module.exports = __webpack_public_path__ + "img/vol06_character_img02_sp.7381f46e.png";